import Vue from 'vue';
import VueRouter from 'vue-router';
import Router from './router';
import { getToken, gotoOAuth, ifBindPhone, ifDisable } from 'common/js/ovoSystem';
Vue.use(VueRouter);
// 路由配置
const RouterConfig = {
  routes: Router,
  mode: 'history',
};
//vue-router的bug
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  if (to.name === 'mine') {
    document.title = '个人中心';
  }else{
    document.title = '万店上选';
  }
  //如果进入的是需要token的页面，判断是否登录
  if (to.meta && to.meta.needToken) {
    if (!getToken()) {
      //没有登陆过就跳转鉴权页
      let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      if (ua.match(/MicroMessenger/i) === "micromessenger" || (Array.isArray(ua.match(/MicroMessenger/i)) && ua.match(/MicroMessenger/i)[0] === "micromessenger")) {
        //在微信中打开
        gotoOAuth()
        return
      }else{
        alert('请使用微信访问此网站')
      }
    }else {
      //验证是否绑定过手机
      if (to.name !== 'bindphone' && ifBindPhone() == '0') {
        next({
          name: 'bindphone'
        })
        return
      }
      //账号被禁用，则不能进商城
      if (ifDisable() == 1) {
        next({
          name: 'home'
        })
        alert('该账号已被禁用')
        return
      }
      next();
    }
  }else{
    next()
  }
});
export default router;
